// extracted by mini-css-extract-plugin
export var box = "_7g-1";
export var checkboxRow = "_7g-8";
export var checked = "_7g-2";
export var descriptionSpacer = "_7g-a";
export var disabled = "_7g-3";
export var icon = "_7g-6";
export var input = "_7g-0";
export var labelSpacer = "_7g-9";
export var medium = "_7g-5";
export var small = "_7g-4";
export var text = "_7g-7";